import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, Lock, Eye, FileText } from 'lucide-react';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const content = t('privacy.content', { returnObjects: true });

  const icons = [<ShieldCheck />, <Lock />, <Eye />, <FileText />];

  return (
    <div className="pt-10">
      <section className="bg-dark-green py-20 text-white text-center">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('privacy.title')}</h1>
          <p className="text-gold-light font-medium">{t('privacy.lastUpdated')}</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-12">
            {content.map((item, index) => (
              <div key={index} className="flex flex-col md:flex-row gap-8 items-start">
                <div className="bg-cream-off p-4 rounded-2xl text-gold-primary flex-shrink-0">
                  {React.cloneElement(icons[index % icons.length], { size: 32 })}
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-dark-green mb-4">{item.heading}</h2>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 p-10 bg-cream-off rounded-[2rem] border border-gold-primary/20 text-center">
            <h3 className="text-2xl font-bold text-dark-green mb-4">Questions About Our Privacy Policy?</h3>
            <p className="text-gray-600 mb-8">If you have any questions, please contact us at vskassociates91665@gmail.com</p>
            <a 
              href="mailto:vskassociates91665@gmail.com"
              className="inline-block bg-dark-green text-white px-10 py-4 rounded-xl font-bold hover:bg-dark-green-deep transition-all shadow-lg"
            >
              Contact Support
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
